/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ButtonType1.vue?vue&type=template&id=3103b09c&scoped=true"
import script from "./ButtonType1.vue?vue&type=script&lang=js"
export * from "./ButtonType1.vue?vue&type=script&lang=js"
import style0 from "./ButtonType1.vue?vue&type=style&index=0&id=3103b09c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3103b09c",
  null
  
)

export default component.exports